import React from 'react';

import styles from '../../styles/componentStyle/textBox/textBox.scss';

/**
 * プレースホルダー付きのテキストボックス ( メインは検索等で使用する )
 * @props {string}label:ラベル
 * @props {string}class:インプットタグのclass属性
 * @props {string}name:インプットタグのname属性
 * @props {string}placeholder:テキストボックス内の初期表示する内容
 * @props {string}value:変化させたいステートのパラメーター
 * @props {function}onInput:テキストボックスに文字を入力した時の処理
 * @props {function}onBlur:テキストボックスからフォーカスが離れた時の処理
 */
export class TextBox extends React.Component {
  constructor(props) {
    super(props);
    if (
      this.props.onInput !== undefined &&
      typeof this.props.onInput === 'function'
    ) {
      this.onInput = this.props.onInput.bind(this);
    } else {
      console.warn('onInput is not function');
    }

    if (
      this.props.onBlur !== undefined &&
      typeof this.props.onBlur === 'function'
    ) {
      this.onBlur = this.props.onBlur.bind(this);
    } else {
      console.warn('onBlur is not function');
    }
  }

  // 画面表示
  render() {
    return (
      <div className={styles.textBox}>
        <div className='text-box'>
          <div className='text-box__label'>
            <span className='label'>{this.props.label}</span>
          </div>
          <div className='text-box__element'>
            <input
              type='text'
              className={`${this.props.class}` + ' text'}
              name={this.props.name}
              placeholder={this.props.placeholder}
              value={this.props.value}
              onInput={this.onInput}
              onBlur={this.onBlur}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/textbox/TextBox.jsx